import moment from "moment";

export function localeDate(date, lang = 'nl') {
    moment.locale(lang);
    return moment(date);
}